import { useEffect, useRef } from "react";
import { useCookieConsent } from "./useCookieConsent";

const GA_MEASUREMENT_ID = "G-6SWGCX90KX";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

function loadGtagScript(): void {
  if (document.querySelector(`script[src*="googletagmanager"]`)) return;

  const script = document.createElement("script");
  script.async = true;
  script.crossOrigin = "anonymous";
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer ?? [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);
}

export function useGoogleAnalytics(): void {
  const { consent } = useCookieConsent();
  const loaded = useRef(false);

  useEffect(() => {
    if (!consent.isResolved || !consent.analytics || loaded.current) return;

    loaded.current = true;
    loadGtagScript();
  }, [consent.isResolved, consent.analytics]);
}
